<template lang="html">
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New User Group</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" icon="save">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Code*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="form.code" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Name*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="form.name"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Enable*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="form.enable"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item value="1" text="Yes"/>
                                    <vs-select-item value="0" text="No"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">Access</vs-divider>
                <vs-table :data="form.access" hoverFlat pagination max-items="10" search>
                    <template slot="thead">
                        <vs-th><p @click="checkAccess('all')" style="cursor: pointer">Menu Name</p></vs-th>
                        <vs-th><p @click="checkAccess('create')" style="cursor: pointer">Create</p></vs-th>
                        <vs-th><p @click="checkAccess('read')" style="cursor: pointer">Read</p></vs-th>
                        <vs-th><p @click="checkAccess('update')" style="cursor: pointer">Update</p></vs-th>
                        <vs-th><p @click="checkAccess('delete')" style="cursor: pointer">Delete</p></vs-th>
                        <vs-th><p @click="checkAccess('print')" style="cursor: pointer">Print</p></vs-th>
                        <vs-th><p @click="checkAccess('export')" style="cursor: pointer">Export</p></vs-th>
                        <vs-th><p @click="checkAccess('confirm')" style="cursor: pointer">Confirm</p></vs-th>
                        <vs-th><p @click="checkAccess('enable')" style="cursor: pointer">Enable</p></vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, indextr) in data" :key="indextr" >
                            <vs-td>
                                <p @click="checkModule(tr.id)" style="cursor: pointer">{{ tr.name }}</p>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.create"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.read"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.update"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.delete"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.print"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.export"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.confirm"></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.enable"></vs-checkbox>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import { AgGridVue } from "ag-grid-vue";

	export default {
		components:{
            vSelect,
            AgGridVue
		},
		data(){
			return {
                isLoading: false,
                form: {
                    code: '',
                    name: '',
                    enable: 1,
                    access: []
                },
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true;
                this.$http.get('rolemanagement/menu/all')
                .then(res => {
                    this.form.access = res.data.map(item => {
                        return {
                            id: item.id,
                            name: item.menu,
                            create: 0,
                            read: 0,
                            update: 0,
                            delete: 0,
                            print: 0,
                            export: 0,
                            confirm: 0,
                            enable: 0
                        }
                    })
                    this.isLoading = false;
                })
                .catch(error => this.handleError(error))
            },
            submitForm() {
                this.isLoading = true;
                this.$http.post("rolemanagement/usergroup/store", this.form)
                .then(res => {
                    this.isLoading = false;
                    const message = res.data.message ? res.data.message : 'Success.'
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                    
                    this.$router.push({
                        name: "usergroup-view",
                        params: {
                            id: res.data.id
                        }
                    });
                })
                .catch(error => this.handleError(error));
            },
            back() {
                this.$vs.dialog({
                    color: 'warning',
                    title: 'Leave Page',
                    text: 'Changes you made may not be saved',
                    acceptText: 'Leave Page',
                    accept: () => this.$router.push({
                        name: 'usergroup'
                    }),
                })
            },
            checkModule(id) {
                const index = this.form.access.findIndex(p => p.id === id);
                if(index !== -1) {
                    const current = this.form.access[index];
                    const first = current.create;
                    current.create = !first;
                    current.read = !first;
                    current.update = !first;
                    current.delete = !first;
                    current.print = !first;
                    current.export = !first;
                    current.confirm = !first;
                    current.enable = !first;
                }
            },
            checkAccess(type) {
                if(type !== 'all') {
                    const first = this.form.access[0][type];
                    
                    this.form.access.map(item => {
                        item[type] = !first;
                    });
                }
                else {
                    const first = this.form.access[0].create;

                    this.form.access.map(item => {
                        item.create = !first;
                        item.read = !first;
                        item.update = !first;
                        item.delete = !first;
                        item.print = !first;
                        item.export = !first;
                        item.confirm = !first;
                        item.enable = !first;
                    });
                }
            }
        },
        mounted() {
            this.fetchData();
        }
	}
</script>

<style>

</style>